// extracted by mini-css-extract-plugin
module.exports = {"parentContainer":"loginPage_parentContainer__327Ix","childContainer":"loginPage_childContainer__2WL0H","logo":"loginPage_logo__3hdLJ"};